import React from 'react';
import PropTypes from 'prop-types';
import { Deserializer } from 'jsonapi-serializer';
import Raven from 'raven-js';

import ReconnectingWebSocket from 'containers/ReconnectingWebSocket';

import ChatRooms from 'api/resources/chatRooms';
import { processErrorByAlert } from 'utils/getErrors';

const TIME = 2 * 60 * 1000; // 2 минуты

class ChatRoomAutoFinish extends React.PureComponent {
  timerId = undefined;

  componentDidMount() {
    this.resetFinishTimer();
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.finish(prevProps.id);
      this.resetFinishTimer();
    }

    if (this.props.lastCreatedAt !== prevProps.lastCreatedAt) {
      this.resetFinishTimer();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timerId);
  }

  handleTimeout = () => {
    this.finish(this.props.id);
  }

  resetFinishTimer() {
    clearTimeout(this.timerId);
    this.timerId = setTimeout(this.handleTimeout, TIME);
  }

  async finish(chatRoomId) {
    try {
      const response = await ChatRooms.finish({
        chatRoomId,
        include: 'last_message,user,user.avatar,user.oauth_providers',
      });

      const chatRoom = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);
      this.props.onFinished(chatRoom);
    } catch (err) {
      processErrorByAlert(err);
      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    if (!this.props.userId) return null;
    return <ReconnectingWebSocket path={`/_ws-mobile/c/chats/main_chat:${this.props.userId}`} />;
  }
}

ChatRoomAutoFinish.propTypes = {
  id: PropTypes.string,
  lastCreatedAt: PropTypes.number,
  userId: PropTypes.string,

  onFinished: PropTypes.func,
};

ChatRoomAutoFinish.defaultProps = {
  id: '',
  lastCreatedAt: 0,
  userId: '',

  onFinished: () => {},
};

export default ChatRoomAutoFinish;
